let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7f4x9")).then(() => parcelRequire('K5ywD'));